
declare const ethicalads: any

type AdProps = {
	type: 'text' | 'image',
	id: string,
}
export function Ad({  }: AdProps) {

	return <></>
}
